<template>
    <b-overlay :show="busy" rounded="sm">
        <!-- {{type}} -->
        <!-- {{ value }} -->
        <!-- {{ openingbalances.changed  }} -->
        <!-- {{ openingbalances.items  }} -->
        <b-card class="standardpage border-none ">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="openingbalances.icon" class="mr-1"></i>
                        <span>{{ openingbalances.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>
            <div class="mt-2 availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0 px-0">
                        <div class="px-0 mb-2" v-if="openingbalances.addperiod">
                            <!-- hello, i need and input with an X clear and Save It button -->
                            <b-row>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Period" label-for="period" label-cols="12">
                                        <b-input-group>
                                            <b-form-input type="text" v-model="periodnext" placeholder="Enter period"
                                                size="sm"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary" @click="period = ''">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="auto" class="mt-3">
                                    <b-button squared size="sm" variant="primary" @click="createit">
                                        <i class="fa fa-check"></i>
                                        Create It
                                    </b-button>
                                </b-col>
                                <b-col class="text-left my-auto">
                                    <div v-if="busy">
                                        <i class="fa fa-spinner fa-spin text-primary"></i>
                                    </div>
                                    <div v-else>
                                        <span v-html="message_create"></span>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="px-0 mb-2 z-0"
                            v-if="openingbalances.pastespecial && permissionvalid('systems.development')">
                            <b-row class="mt-2" no-gutters align-v="center">
                                <b-col cols="auto">
                                    <b-form-group>
                                        <b-form-checkbox-group id="segments_paste_selected"
                                            v-model="openingbalances.paste_selected"
                                            :options="openingbalances.paste_options" value-field="id"
                                            text-field="label"></b-form-checkbox-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="auto" class="ml-4">
                                    <b-form-group label="Period" label-for="period" label-cols="2" class="label-pt-5px">
                                        <b-input-group>
                                            <b-form-input type="text" v-model="periodnext" placeholder="Enter period"
                                                size="sm"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary" @click="period = ''">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="auto" class="text-right ml-auto">
                                    <b-row>
                                        <!-- <b-col cols="auto">
                    <b-link squared size="sm" variant="outline-primary" @click="download()">
                      <i class="fa fa-download"></i>
                      Template
                    </b-link>
                  </b-col> -->
                                        <b-col cols="auto">
                                            <b-link size="sm" variant="outline-primary"
                                                @click="openingbalances_saveit()">
                                                <i class="fa fa-floppy-o"></i>
                                                Save It
                                            </b-link>
                                        </b-col>
                                        <b-col cols="auto">
                                            <b-link size="sm" variant="outline-primary"
                                                @click="openingbalances_headers()">
                                                Headers
                                            </b-link>
                                        </b-col>
                                        <b-col cols="auto">
                                            <b-link size="sm" variant="outline-primary"
                                                @click="openingbalances_paste_read()">
                                                <i class="fa fa-magic"></i>
                                                Read It
                                            </b-link>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12">
                                    <b-form-group label-cols="12">
                                        <b-form-textarea id="data" v-model="openingbalances.paste"
                                            placeholder="Paste opening balances data" rows="6"
                                            class="smalltextarea courier"></b-form-textarea>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="mt-0 mb-1 text-center etable autoadd">
                            <e-table :refid="openingbalances.refid" :busy="openingbalances.busy"
                                :icon="openingbalances.icon" :showtoolbar="openingbalances.showtoolbar"
                                :showfab="openingbalances.showfab" :showsheets="openingbalances.showsheets"
                                :showpages="openingbalances.showpages" :showrowcount="openingbalances.showrowcount"
                                :showautoadd="openingbalances.showautoadd" :tools="openingbalances.tools"
                                :toolbarlibrary="openingbalances.toolbarlibrary" :fields="openingbalances.fields"
                                :items="openingbalances.items" :downloaded="openingbalances.downloaded"
                                @click="openingbalances_click" @select="openingbalances_select" @changed="changedit" />
                        </div>
                    </b-card-body>
                </b-card>
            </div>

            <!-- {{ lines }} -->
            <b-card-footer class="nopadding mt-2">
                <b-row no-gutters>
                    <b-col cols="auto" class="text-left mr-3">
                        <b-button v-if="user.permissions.includes('setup_openingbalances.admin')" squared size="sm"
                            variant="primary" @click="saveit">
                            <i class="fa fa-check"></i>
                            Save It
                        </b-button>
                    </b-col>
                    <b-col class="text-left my-auto">
                        <div v-if="busy">
                            <i class="fa fa-spinner fa-spin text-primary"></i>
                        </div>
                        <div v-else>
                            <span v-html="message"></span>
                        </div>
                    </b-col>
                    <b-col class="text-right" cols="8">
                        <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                            <i class="fa fa-chevron-left pr-1"></i>
                            Back
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-footer>

        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "OpeningBalances3",
    // props: {
    //     value: { type: Object, required: true },
    // },
    watch: {
        async period() {
            await this.openingbalances_load(0);
        },
    },
    async mounted() {

        try {
            const response = await this.$apollo.query({
                query: gql`
            query nlcodes {
              nlcodes {
                id
                label
              }
            }
          `,
            });
            this.nlcode_options = response.data.nlcodes;

        } catch (error) {
            console.log(error);
        }
        this.openingbalances.fields[0].options = this.nlcode_options

        await this.openingbalances_load();
    },
    data() {
        return {
            busy: false,
            edited: false,
            readonly: false,
            posted: false,
            message: "",
            message_create:"",
            periodnext: this.$moment().add(1, 'y').format("YYYY04"),
            period: this.$moment().format("YYYY04"),
            description: null,
            code: null,
            updated_at: null,
            updated_by: null,
            amount: "0.00",
            date_at: {
                startDate: this.$moment().format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            nlcode_options: [],
            postit_disabled: true,
            openingbalances: {
                title: "Opening Balances",
                icon: "fa fa-balance-scale",
                busy: false,
                refid: "openingbalances",
                showtoolbar: true,
                showfab: false,
                showsheets: true,
                showrowcount: true,
                showautoadd: true,
                showpages: false,
                addperiod: false,
                pastespecial: false,
                paste: null,
                paste_selected: ["firstrowheader", "reversenamecap"],
                paste_options: [
                    { id: "firstrowheader", label: "First Row Headers", disabled: true },
                    { id: "secondrowskip", label: "Second Row Skip" },
                    { id: "filldown", label: "Fill Down" },
                ],
                sheets: "",
                tools: "go,download,addperiod,pastespecial,add,deleteconfirm",
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-plus text-orange",
                        position: "toolbar",
                        action: "addperiod",
                        label: "Add Period",
                        component: {
                            name: "",
                        },
                    },
                ],
                fields: [
                    {
                        key: "nllist",
                        label: "NL Code",
                        type: "treeselect",
                        placeholder: "NL Code",
                        class: "text-right w-50pct",
                        clearable: true,
                        multiple: false,
                        options: []
                    },
                    {
                        key: "amount",
                        label: "Amount",
                        type: "text",
                        placeholder: "Amount",
                        class: "text-right",
                        clearable: true,
                        empty: '0.00'
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        type: "text",
                        class: "text-center w-100px d-none d-sm-table-cell",
                        disabled: "true"
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        type: "text",
                        class: "text-center w-150px d-none d-sm-table-cell",
                        disabled: "true"
                    },
                ],
                items: [],
                changed: [],
                selected: [],
                downloaded: [],
            }
        };
    },
    methods: {
        onlyascii(value) {
            // A SPECIFIC REPLACE
            value = value.split('b').join('')
            value = value.normalize('NFD').replace(/([\u0300-\u036f]|[^\x20-\x7E])/g, '')
            return value
        },
        linesAll(evt) {
            const list = this.allLinesChecked
                ? []
                : this.value.lines.slice(0, this.value.lines.length);
            this.lines = list;
        },
        toggleLine(evt, index) {
            console.log("toggleLine", evt, index);

            const savedIndex = this.savedIndex;
            this.savedIndex = index;

            // If this is the first pass or no shift key was
            // pressed, just bail.
            if (savedIndex === null || !evt.shiftKey) return;

            // Shift-clicked the same message :-/
            if (index === savedIndex) return;

            // Get the subset of the message list between the
            // two indicies.
            // console.time("toggle range");
            const subset = this.items.slice(
                Math.min(index, savedIndex),
                Math.max(index, savedIndex) + 1
            );
            // Determine the operation based on the checked state
            // of the clicked checkbox.
            const toggleFn = evt.currentTarget.checked
                ? addCheckedSubset
                : removeCheckedSubset;

            this.lines = toggleFn(this.lines, subset);
            console.log("these are checked", this.lines);
            // console.timeEnd("toggle range");
        },
        addLine() {
            let state = this.openingbalances;
            let _copy = { ...state.items[state.items.length - 1] }
            _copy.id = null
            _copy.code = null
            _copy.amount = (0).toFixed(2)
            _copy.period = null
            _copy.updated_at = null
            _copy.updated_by = null
            this.edited = true
            state.items.push(_copy)
        },
        async delLine(index) {
            if (await this.$bvModal.msgBoxConfirm('Are you sure you want to delete line ' + index + '?',
                {
                    title: 'Please confirm delete action.',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })) {

                let result = []
                for (var j = 0; j < this.lines.length; ++j) {
                    if (j != index - 1) {
                        result.push(this.lines[j])
                    }
                }
                this.lines = result
                this.edited = true
            }
        },
        async openingbalances_load(offset, limit, page) {
            let state = this.openingbalances;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,

                // id: this.id,
                code: this.code,
                period: this.period,
                description: this.description,
                dateformat: "DD/MM/YYYY",
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query setup_openingbalances(
                        $limit: Int
                        $offset: Int
                        $code: String
                        $period: String
                        $description: String
                     
                        ) {
                        setup_openingbalances(
                            limit: $limit
                            offset: $offset
                            code: $code
                            period: $period
                            description: $description
                          
                        ) {
                            id
                            nllist: code
                            description
                            amount
                            updated_at
                            updated_by
                            period
                            sheets
                            rows
                        }
                        }
                    `,
                    variables,
                });

                // USE LOCAL VARIABLE
                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.setup_openingbalances
                } else {
                    state.items = response.data.setup_openingbalances;

                    if (state.items[0].sheets) {
                        state.sheets = state.items[0].sheets

                        let sheetlist = ""
                        for (var j = 0; j < state.sheets.split(",").length; ++j) {
                            sheetlist += "sheet_" + j.toString() + ","
                        }
                        state.tools = "go,download,addperiod,pastespecial,deleteconfirm," + sheetlist
                    }
                }
                state.changed = []

            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },

        async openingbalances_click(a, ss, tools) {
            console.log("openingbalances_click", a, ss);

            let state = this.openingbalances;

            switch (a) {
                case "download_view":
                    state.downloaded = []
                    state.downloaded = this.state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.openingbalances_load(0, 0);
                    break;

                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    break;

                case "go":
                    this.component = null;
                    this.openingbalances_load();
                    break;

                case "save":
                    this.saveit(ss);
                    break;

                case "delete":
                    if (ss.length > 0) {
                        await this.deleteit(ss)
                    }
                    break;

                case "addperiod":
                    if (state.pastespecial) { state.pastespecial = false }
                    state.addperiod = !state.addperiod
                    break;
                case "pastespecial":
                    if (state.addperiod) { state.addperiod = false }
                    state.pastespecial = !state.pastespecial
                    break;

                case "sheet_0":
                case "sheet_1":
                case "sheet_2":
                case "sheet_3":
                case "sheet_4":
                case "sheet_5":
                case "sheet_6":
                    this.period = tools.find((o) => o.action == a).label;
                    break;
            }
        },
        async openingbalances_select(ss, tools) {

            let state = this.openingbalances;

            state.selected = ss;
            let tool = null;

            let sheets = state.sheets.split(",")
            for (var j = 0; j < sheets.length; ++j) {
                tool = tools.find((o) => o.action == 'sheet_' + j.toString());
                tool.icon = "fa fa-balance-scale";
                tool.label = sheets[j]
                tool.disabled = false
            }

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "add", "download", "addperiod", "pastespecial"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                // enabled = ["edit"];
                // enabled.forEach(function (action, index) {
                //     tool = tools.find((o) => o.action == action);
                //     if (tool) {
                //         tool.disabled = ss.length == 1 ? false : true;
                //     }
                // });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },
        async deleteit(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation setup_openingbalances_delete($rows: [setup_openingbalances_input]) {
                        setup_openingbalances_delete(rows: $rows) {
                            id
                        }
                        }
                    `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.openingbalances_load();
        },
        async openingbalances_paste_read() {

            let state = this.openingbalances;

            if (state.paste) {
                state.busy = true
                let rows = tabToObjArr(state.paste)

                let rowstart = 1
                if (state.paste_selected.includes("secondrowskip")) {
                    rowstart += 1
                }

                // MAKE OBJECT ITEMS
                let items = []
                for (let i = rowstart; i < rows.length; i++) {
                    items.push(rows[i])
                }

                if (state.paste_selected.includes("filldown")) {
                    let lastitem = {}
                    for (let i = 0; i < items.length; i++) {
                        let item = items[i]
                        for (let prop in lastitem) {
                            if (!item[prop]) {
                                if (lastitem[prop]) {
                                    item[prop] = lastitem[prop]
                                }
                            }
                        }
                        lastitem = item
                    }
                }

                let found = null

                rows = []
                for (let i = 0; i < items.length; i++) {
                    let obj = items[i]

                    let openingbalance = {}

                    for (let prop in obj) {

                        let values = []
                        try {
                            if (obj[prop]) {
                                let data = obj[prop].trim().toUpperCase()
                                let colname = prop.toLowerCase()

                                if (colname == 'period') {
                                    openingbalance.period = data
                                }

                                if (colname == 'nlcode' || colname == 'code') {
                                    openingbalance.nlcode = data
                                }

                                if (colname == 'amount' || colname == 'value') {
                                    if (data) {
                                        openingbalance.amount = parseFloat(data).toFixed(2)
                                    }
                                }

                            }

                        } catch (error) {
                            console.log('error here', error)
                        }
                    }
                    // DE-DUPLICATE
                    found = rows.find(o => o.yourref == openingbalance.yourref)
                    if (!found) {
                        rows.push(openingbalance)
                    }
                }
                console.log('rows=', rows)

                state.items = rows

                state.busy = false
            }

        },
        async openingbalances_headers() {

            let state = this.openingbalances;

            let content = state.paste
            state.paste = "SLAC\tPO\n"
            if (content) {
                state.paste += content
            }
        },
        async saveit(ss) {

            let state = this.openingbalances;
            if (state.changed.length == 0) { return }

            this.busy = true;

            let rows = []
            for (var j = 0; j < state.changed.length; ++j) {
                rows.push({ id: state.changed[j].id, code: state.changed[j].nllist, amount: state.changed[j].amount })
            }

            let variables = { rows };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation setup_openingbalances_save(
                        $rows: [setup_openingbalances_input]             
                    ) {
                        setup_openingbalances_save(rows: $rows) {
                            id
                            code
                            description
                            period
                            amount   
                            updated_at
                            updated_by                 
                        }
                    }
                    `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }
            await this.openingbalances_load();
            this.busy = false;
        },
        async changedit(e) {
            let state = this.openingbalances;
            let found = state.changed.find((o) => o.id == e.id)
            if (!found && e.id) {
                state.changed.push(e)
                found = state.changed.find((o) => o.id == e.id)
            }
            found = e
        },
        async createit() {

            this.busy = true;

            let variables = { period: this.periodnext };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation setup_openingbalances_addperiod(
                        $period: String             
                        ) {
                            setup_openingbalances_addperiod(period: $period)
                        }
                    `,
                    variables,
                });
                this.message_create = "<span class='text-primary'>Created it.</span>";

                await this.openingbalances_load();

            } catch (error) {
                this.message_create = "<span class='text-danger'>" + error.message_create + "</span>";
            }

            this.period = this.periodnext

            this.busy = false;

        }

    },
};
</script>